import { computeAllowableOverlapRanges as sharedComputeAllowableOverlapRanges } from '@da-g3-acl/shared/common';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import type { LengthRange } from '../../../../types/lengthRange';

type DepthRange = { depthFrom: number; depthTo: number };

export function computeAllowableOverlapRanges(
	otherIntervals: DepthRange[],
	maxOverlapCount: number,
	bounds?: LengthRange,
): LengthRange[] {
	return sharedComputeAllowableOverlapRanges(otherIntervals, maxOverlapCount, bounds);
}
